const copyText = async (val,el,textEl,applyDiscount=false) => {
    try {
        if (textEl) {
            const targetEl = el && el.matches(textEl) ? el : el?.querySelector(textEl);
            if (targetEl) {
                targetEl.innerHTML = "Copied";
            } else {
                if (el) el.innerHTML = "Copied";
            }
        } else if (el) {
            el.querySelector('small').style.display = 'flex';
        } else {
            document.getElementById("textCopied").style.display = "block";
        }
        if (applyDiscount) {
            const body = JSON.stringify({
                discount: val,
                sections: document.querySelector('xo-cart-mini')?.id || 'xo-cart-mini',
                section_url: window.location.pathname
            });
            fetch(`/cart/update.js`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/javascript',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: body
            })
            .then((response) => response.json())
            .then((data) => {
                xoStore.set('xo-cart', (prevState) => ({
                    ...prevState,
                    sections: data.sections || prevState.sections,
                    size: data.item_count || prevState.size,
                    data: data
                }))('xo-cart/refresh');
            })
        }
        if (navigator.clipboard && navigator.permissions) {
            await navigator.clipboard.writeText(val);
            return;
        }
        const textArea = document.createElement('textArea')
        textArea.value = val
        textArea.style.width = 0
        textArea.style.position = 'fixed'
        textArea.style.left = '-999px'
        textArea.style.top = '10px'
        textArea.setAttribute('readonly', 'readonly')
        document.body.appendChild(textArea)
        textArea.select()
        const success = document.execCommand('copy');
        if (!success) {
            throw new Error('无法复制文本');
        }
        document.body.removeChild(textArea);
    } catch (err) {
        document.getElementById("textCopied").style.display = "block";
        document.getElementById("textCopied").innerHTML = "Copy Failed!";
    }
};
function closeEuPopup(){
  document.getElementById("eu-popup-section").style.display = "none";
  localStorage.setItem("is_ip_eu",true)
}
function goLink(res, e, newTab = false) {
 
  if (e && typeof e.stopPropagation === 'function') {
    e.stopPropagation();
  }

  let goUrl = res;
  if (res === 'https://eu.phomamo.com?utm_source=phomemo&utm_medium=web&utm_term=popop') {
    if (location.href.includes('utm_source=ggads') || location.href.includes('utm_source=bingads')
      || location.href.includes('utm_source=fbads') || location.href.includes('utm_source=phomemo')) {
      goUrl = location.href.replace('phomamo.com', 'eu.phomamo.com');
    }
    closeEuPopup()
  }
  if (newTab) {
    window.open(goUrl, '_blank');
  } else {
    location.href = goUrl;
  }
}

document.addEventListener('DOMContentLoaded', function() {
    function applyAutoDiscountCodes() {
        document.querySelectorAll('.xo-collapse[data-auto-discount-code]').forEach(function(container) {
            const autoCode = container.dataset.autoDiscountCode;
            if (!autoCode) return;

            const input = container.querySelector('xo-cart-discount input[name="discount"]');
            if (!input || input.value) return;

            input.value = autoCode;
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }
    setTimeout(applyAutoDiscountCodes, 500);
    const xoStore = window.xoStore || (window.xobuildercomponents && window.xobuildercomponents.xoStore);
    if (xoStore && typeof xoStore.subscribe === 'function') {
        let debounceTimer = null;
        xoStore.subscribe('xo-cart', function() {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(applyAutoDiscountCodes, 300);
        });
    }
    
    let isEuList=['DE','GB','FR','IT','CZ','ES','BE','NL','PL','SE','FI','DK','IE','LU','MC','CY','PT','AT','NO','HU','SK','SI','HR','MT','LT','BG','EE','GR','LV','RO','CH','IS','LI'].map(item=>item.toUpperCase());
    if(isEuList.indexOf(Shopify.country)>-1&&!localStorage.getItem('is_ip_eu')&&document.getElementById("eu-popup-section")){
        document.getElementById("eu-popup-section").style.display = "flex";
    }
    // const accountEl = document.querySelector("shopify-account");
    // const shadowRoot = accountEl?.shadowRoot;
    // const isLoggedIn = !!shadowRoot?.querySelector(".account-button__avatar-image");
    // const hasClicked = sessionStorage.getItem("account_clicked_once");
    // if (!isLoggedIn && !hasClicked) {
    //     sessionStorage.setItem("account_clicked_once", "true");
    //     shadowRoot?.querySelector(".account-button")?.click();
    // }
});

 function openLevel2(panelId) {
    const targetPanel = document.getElementById(panelId);
    const level1Panel = document.getElementById('level1-panel');
    if (targetPanel && level1Panel) {
      level1Panel.classList.add('-translate-x-full');
      targetPanel.classList.remove('translate-x-full');
      targetPanel.classList.add('translate-x-0');
    }
  }

  function closeLevel2(panelId) {
    const targetPanel = document.getElementById(panelId);
    const level1Panel = document.getElementById('level1-panel');
    if (targetPanel && level1Panel) {
      targetPanel.classList.remove('translate-x-0');
      targetPanel.classList.add('translate-x-full');
      level1Panel.classList.remove('-translate-x-full');
    }
  }

  function toggleAccordion(triggerEl, contentId, iconId) {
    const currentContent = document.getElementById(contentId);
    const currentIcon = document.getElementById(iconId);
    const parentGroup = triggerEl.closest('.accordion-group');

    const isOpen = currentContent.style.maxHeight && currentContent.style.maxHeight !== '0px';
    if (parentGroup) {
      const allContents = parentGroup.querySelectorAll('.accordion-content');
      const allIcons = parentGroup.querySelectorAll('.accordion-icon');

      allContents.forEach(content => {
        content.style.maxHeight = '0px';
      });

      allIcons.forEach(icon => {
        icon.classList.remove('rotate-180');
      });
    }
    if (!isOpen) {
      currentContent.style.maxHeight = currentContent.scrollHeight + "px";
      currentIcon.classList.add('rotate-180');
    }
  }